import FieldDefs from './LostKeywordsFieldDefs'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'
import LostKeywordsGny from "./LostKeywordsGny";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.lost_keywords_fields", isGoogleGny() ? LostKeywordsGny :FieldDefs),
            sortOrder: [
                {
                    field: '__slot:pos',
                    sortField: 'pos',
                    direction: 'asc'
                }
            ],
            additionalActions: [
                {
                    label: this.$t("lang.report.lost_keywords.open_unique"),
                    icon: ["fa", "fa-object-ungroup"],
                    event: function(){

                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'lostkeywords';

                        window.open('/' + window.locale + '/tools/unique#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');

                    }
                },
                {
                    label: this.$t("lang.report.lost_keywords.open_delete_double"),
                    icon: ["fa", "fa-trash-o"],
                    event: function(){

                        let vars = {};

                        this.$parent.$parent.$refs.ksTable.apiUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                            vars[key] = value;
                        });

                        vars['filter'] = this.getQuery();
                        vars['from'] = 'lostkeywords';

                        window.open('/' + window.locale + '/tools/delete-double#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');

                    }
                },
            ],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
